import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Table from '../common/Table';
import ConstElement from '../common/ConstElement';
import AvatarEditor from '../../modules/react-avatar-editor/';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class EditStaff extends Component {
    constructor(props) {
        super(props);
            this.state = {
                staff: {identification_img_file_crop:'', profile_img_file_crop:'', identification_img_file_back_crop:'', identification_img_file_back2_crop:'', date_interview: null, birthday: null},
                cities:[],
                prefs:[],
                imgIdentification:{
                    img:'',
                    name:'',
                    width:0,
                    height:0
                },
                imgProfile:{
                    img:'',
                    name:'',
                    width:0,
                    height:0
                },
                imgIdentificationFileBack:{
                    img:'',
                    name:'',
                    width:0,
                    height:0
                },
                imgIdentificationFileBack2:{
                    img:'',
                    name:'',
                    width:0,
                    height:0
                },
            }
        axios.get('/api/config/get/img_profile_img_file').then(response => {
            this.setState({
                imgProfile: {
                    img: '',
                    name: '',
                    width: response.data.width,
                    height: response.data.heigh
                }
            })
        })
        axios.get('/api/config/get/img_identification_img_file').then(response => {
            this.setState({
                imgIdentification: {
                    img: '',
                    name: '',
                    width: response.data.width,
                    height: response.data.heigh
                }
            })
        })
        axios.get('/api/config/get/img_identification_img_file_back').then(response => {
            this.setState({
                imgIdentificationFileBack: {
                    img: '',
                    name: '',
                    width: response.data.width,
                    height: response.data.heigh
                }
            })
        })
        axios.get('/api/config/get/img_identification_img_file_back2').then(response => {
            this.setState({
                imgIdentificationFileBack2: {
                    img: '',
                    name: '',
                    width: response.data.width,
                    height: response.data.heigh
                }
            })
        })
        this.saveData = this.saveData.bind(this);
        this.setData = this.setData.bind(this);
        this.getData = this.getData.bind(this);
        this.handleInptChange = this.handleInptChange.bind(this);
        this.handlePreviewImg = this.handlePreviewImg.bind(this);
        this.cropImageIdentification = this.cropImageIdentification.bind(this);
        this.cropImageIdentificationFileBack = this.cropImageIdentificationFileBack.bind(this);
        this.cropImageIdentificationFileBack2 = this.cropImageIdentificationFileBack2.bind(this);
        this.handleChangeEditDateInterview = this.handleChangeEditDateInterview.bind(this);
        this.handleChangeBirthday = this.handleChangeBirthday.bind(this);
        this.updateStatus = this.updateStatus.bind(this);
        this.deleteAccount = this.deleteAccount.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.updateStatusRecoverAccount = this.updateStatusRecoverAccount.bind(this);
    }
    
    /**
     * Process change date interview
     */
    handleChangeEditDateInterview(date) {
        let staffData = Object.assign({}, this.state.staff);
        staffData['date_interview'] = date;
        this.setState({staff: staffData});
    }
    
    /**
     * Process change birthday
     */
    handleChangeBirthday(date) {
        let staffData = Object.assign({}, this.state.staff);
        staffData['birthday'] = date;
        this.setState({staff: staffData});
    }
    
    /**
     * Init data
     */
    componentWillMount() {
        axios.get('/api/cities').then(response => {
            this.setState({
                cities: response.data
            });
        })
        axios.get('/api/prefs').then(response => {
            this.setState({
                prefs: response.data
            });
        })
        
        if (this.props.match.params.hasOwnProperty('id')) {
            //Edit staff
            const staffId = this.props.match.params.id
            axios.get('/api/staffs/' + staffId).then(response => {
                response.data.password = '';
                response.data.password_confirmation = '';
                let staffData = Object.assign({}, this.state.staff);
                staffData = response.data;
                this.setState({staff: staffData});
            }).catch(() => {
                this.props.history.push('/_404');
            })
        }
    }
    
    /**
     * Set data
     * data: Object Staff
     */
    setData(data) {
        this.setState({
            staff: data
        })
    }
    
    /**
     * Get object staff
     */
    getData() {
        return this.state.staff;
    }
    
    /**
     * Listen change inputs
     */
    handleInptChange(event) {
        let staffData = Object.assign({}, this.state.staff);
        staffData[event.target.name] = event.target.value;
        this.setState({staff: staffData});
    }
    
    /**
     * Load and show image
     * input: Object input
     * idImg: String id of img
     */
    readURL(input, idImg) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            let staffData = Object.assign({}, this.state.staff);
            let imgIden = Object.assign({}, this.state.imgIdentification);
            let imgIdenFileBack = Object.assign({}, this.state.imgIdentificationFileBack);
            let imgIdenFileBack2 = Object.assign({}, this.state.imgIdentificationFileBack2);
            reader.onload = (e) => {
            //Save origin img.
            staffData[input.name] = e.target.result;
            this.setState({staff: staffData});
            if (input.name == 'identification_img_file') {
                //Set config for avatareditor
                imgIden['img'] = staffData[input.name];
                imgIden['name'] = input.name;
                this.setState({imgIdentification: imgIden});
                //this.cropImage();
                $('#img-identification_img_file').hide()
                $('#identificationCanvas').show()
                $('#btn-crop-image-file').addClass('cls-is-showing');
            } else if (input.name == 'identification_img_file_back') {
                //Set config for avatareditor
                imgIdenFileBack['img'] = staffData[input.name];
                imgIdenFileBack['name'] = input.name;
                this.setState({imgIdentificationFileBack: imgIdenFileBack});
                //this.cropImage();
                $('#img-identification_img_file_back').hide()
                $('#identificationFileBackCanvas').show()
                $('#btn-crop-image-file-back').addClass('cls-is-showing');
            } else if (input.name == 'identification_img_file_back2') {
                //Set config for avatareditor
                imgIdenFileBack2['img'] = staffData[input.name];
                imgIdenFileBack2['name'] = input.name;
                this.setState({imgIdentificationFileBack2: imgIdenFileBack2});
                //this.cropImage();
                $('#img-identification_img_file_back2').hide()
                $('#identificationFileBack2Canvas').show()
                $('#btn-crop-image-file-back2').addClass('cls-is-showing');
            } else {
                //Call resize image
                this.resizeImage(e.target.result, this.state.imgProfile.width, this.state.imgProfile.height, 'img-profile_img_file');
            }
        }
            reader.readAsDataURL(input.files[0]);
        }
    }

    /**
     * Resize image
     */
    resizeImage(data, MAX_WIDTH, MAX_HEIGHT, idName) {
        var img = new Image();
        img.onload = () => {
            width = this.width;
            height = this.height;
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            var width = img.width;
            var height = img.height;
            if (width > height) {
                if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width;
                        width = MAX_WIDTH;
                }
            } else {
                if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height;
                        height = MAX_HEIGHT;
                }
            }
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);
            var dataurl = canvas.toDataURL("image/png");
            document.getElementById(idName).src = dataurl;
            let staffData = Object.assign({}, this.state.staff);
            staffData["profile_img_file" + "_crop"] = dataurl;
            this.setState({staff: staffData});
        };
        img.src = data;
    }
    
    /**
     * Show image
     */
    
    handlePreviewImg(event){
        if(event.currentTarget.files[0].size > 10485760){
            alert("10MB以下の画像をアップロードしてください");
             document.getElementById(event.currentTarget.getAttribute('id')).value = '';
        } else {
            this.readURL(event.target, 'img-' + event.target.name);
        }
    }
    
    /**
     * Call function save staff
     */
    saveData() {
        let staff = this.getData();
        if ($('#btn-crop-image-file').hasClass('cls-is-showing') ||
            $('#btn-crop-image-file-back').hasClass('cls-is-showing') ||
            $('#btn-crop-image-file-back2').hasClass('cls-is-showing')) {
                alert("画像をアップロードした後はクロップボタンを押してください。");
                window.scrollTo(0, 0)
                return false;
        }
        if (staff.password == null || staff.password == '') {
            delete staff.password;
            delete staff.password_confirmation;
        }
        //to top
        window.scrollTo(0, 0)
        axios.post('/api/staffs/edit/' + staff.id, staff).then(response => {
            if (response.data.hasOwnProperty('success') && response.data.success) {
                toast.success(response.data.message)
            } else {
                Object.keys(response.data.errors).map((key, i) => {
                        if($.isArray(response.data.errors[key])){
                            response.data.errors[key].map((child, i) => {
                                toast.error(child)
                            })
                        } else {
                            toast.error(response.data.errors[key])
                        }
                    }
                )
            }
        }).catch(error => {
            Object.keys(error.response.data.errors).map((key, i) => {
                    if($.isArray(error.response.data.errors[key])){
                        error.response.data.errors[key].map((child, i) => {
                            toast.error(child)
                        })
                    } else {
                        toast.error(error.response.data.errors[key])
                    }
                }
            )
        })
    }
    
    /**
     * Update status
     */
    updateStatus(e) {
        let staff = this.getData();
        let status = e.currentTarget.getAttribute('status');
        let textStatus = this.processStatus(status);
        let msgAlert = 'このワーカーを承認してよろしいですか？';
        staff.status = status;
        if (status == 8) {
            msgAlert = 'このアカウントを停止してもよろしいですか？';
        }
        if (status == 9) {
            msgAlert = 'このワーカーを非承認にしてよろしいですか？';
        }
        if (window.confirm(msgAlert)) {
            //to top
            window.scrollTo(0, 0)
            axios.post('/api/staffs/update-status/' + staff.id, staff).then(response => {
                if (response.data.hasOwnProperty('success') && response.data.success) {
                    toast.success(response.data.message)
                    let staffData = Object.assign({}, this.state.staff);
                    staffData['status'] = status;
                    this.setState({staff: staffData});
                    $('.cls-status').val(textStatus);
                } else {
                    Object.keys(response.data.errors).map((key, i) => {
                            if($.isArray(response.data.errors[key])){
                                response.data.errors[key].map((child, i) => {
                                    toast.error(child)
                                })
                            } else {
                                toast.error(response.data.errors[key])
                            }
                        }
                    )
                }
            }).catch(error => {
                Object.keys(error.response.data.errors).map((key, i) => {
                        if($.isArray(error.response.data.errors[key])){
                            error.response.data.errors[key].map((child, i) => {
                                toast.error(child)
                            })
                        } else {
                            toast.error(error.response.data.errors[key])
                        }
                    }
                )
            })
        }
    }
    
    /**
     * Update status recover account
     */
    updateStatusRecoverAccount(e) {
        let staff = this.getData();
        let status = e.currentTarget.getAttribute('status');
        let textStatus = this.processStatus(status);
        let msgAlert = 'このアカウントを復旧してもよろしいですか？';
        staff.status = status;
        if (window.confirm(msgAlert)) {
            //to top
            window.scrollTo(0, 0)
            axios.post('/api/staffs/update-status-recover-account/' + staff.id, staff).then(response => {
                if (response.data.hasOwnProperty('success') && response.data.success) {
                    toast.success(response.data.message)
                    let staffData = Object.assign({}, this.state.staff);
                    staffData['status'] = status;
                    this.setState({staff: staffData});
                    $('.cls-status').val(textStatus);
                } else {
                    Object.keys(response.data.errors).map((key, i) => {
                            if($.isArray(response.data.errors[key])){
                                response.data.errors[key].map((child, i) => {
                                    toast.error(child)
                                })
                            } else {
                                toast.error(response.data.errors[key])
                            }
                        }
                    )
                }
            }).catch(error => {
                Object.keys(error.response.data.errors).map((key, i) => {
                        if($.isArray(error.response.data.errors[key])){
                            error.response.data.errors[key].map((child, i) => {
                                toast.error(child)
                            })
                        } else {
                            toast.error(error.response.data.errors[key])
                        }
                    }
                )
            })
        }
    }
    
    /**
     * Delete account
     */
    deleteAccount() {
        let staff = this.getData();
        if (window.confirm('このアカウントを削除してもよろしいですか？')) {
            //to top
            window.scrollTo(0, 0)
            axios.post('/api/staffs/delete-account/' + staff.id, staff).then(response => {
                if (response.data.hasOwnProperty('success') && response.data.success) {
                    toast.success(response.data.message)
                    this.props.history.push('/staffs');
                } else {
                    Object.keys(response.data.errors).map((key, i) => {
                            if($.isArray(response.data.errors[key])){
                                response.data.errors[key].map((child, i) => {
                                    toast.error(child)
                                })
                            } else {
                                toast.error(response.data.errors[key])
                            }
                        }
                    )
                }
            }).catch(error => {
                Object.keys(error.response.data.errors).map((key, i) => {
                        if($.isArray(error.response.data.errors[key])){
                            error.response.data.errors[key].map((child, i) => {
                                toast.error(child)
                            })
                        } else {
                            toast.error(error.response.data.errors[key])
                        }
                    }
                )
            })
        }
    }
    
    /**
     * Handle redirect
     */
    handleRedirect(e) {
        e.preventDefault()
        this.props.history.push(e.currentTarget.getAttribute('href'));
    }
    
    /**
     * Crop image identification file
     */
    cropImageIdentification() {
        if (window.avatarEditorImgIden) {
            const canvas = window.avatarEditorImgIden.getImageScaledToCanvas().toDataURL();
            let staffData = Object.assign({}, this.state.staff);
            staffData[this.state.imgIdentification.name + "_crop"] = canvas;
            this.setState({staff: staffData});
            $('#img-' + this.state.imgIdentification.name).attr('src', canvas);
            $('#img-identification_img_file').show()
            $('#btn-crop-image-file').removeClass('cls-is-showing');
            $('#identificationCanvas').hide()
        }
    }
    
    /**
     * Crop image identification file back
     */
    cropImageIdentificationFileBack() {
        if (window.avatarEditorImgIdenFileBack) {
            const canvas = window.avatarEditorImgIdenFileBack.getImageScaledToCanvas().toDataURL();
            let staffData = Object.assign({}, this.state.staff);
            staffData[this.state.imgIdentificationFileBack.name + "_crop"] = canvas;
            this.setState({staff: staffData});
            $('#img-' + this.state.imgIdentificationFileBack.name).attr('src', canvas);
            $('#img-identification_img_file_back').show()
            $('#btn-crop-image-file-back').removeClass('cls-is-showing');
            $('#identificationFileBackCanvas').hide()
        }
    }
    
    /**
     * Crop image identification file back 2
     */
    cropImageIdentificationFileBack2() {
        if (window.avatarEditorImgIdenFileBack2) {
            const canvas = window.avatarEditorImgIdenFileBack2.getImageScaledToCanvas().toDataURL();
            let staffData = Object.assign({}, this.state.staff);
            staffData[this.state.imgIdentificationFileBack2.name + "_crop"] = canvas;
            this.setState({staff: staffData});
            $('#img-' + this.state.imgIdentificationFileBack2.name).attr('src', canvas);
            $('#img-identification_img_file_back2').show()
            $('#btn-crop-image-file-back2').removeClass('cls-is-showing');
            $('#identificationFileBack2Canvas').hide()
        }
    }
    
    /**
     * Handle show image original
     */
    showImgOriginal(e) {
        var urlImage = e.currentTarget.getAttribute('url');
        var showImg = window.open("", "_blank");
        if (showImg) {
            axios.get(urlImage).then(response => {
                var image = new Image();
                image.src = response.data;
                showImg.document.write(image.outerHTML);
            })
        }
    }
    
    /**
     * Handle show text of status
     */
    processStatus(status) {
        switch(parseInt(status)) {
            case 0: 
                return "未承認";
            case 1:
                return "承認";
            case 8:
                return "停止";
            case 9:
                return "否認";
            default:
                return "選択してください";
        }
    }
    
    /**
     * Handle hover image
     */
    onHoverTooltip() {
        $('[data-toggle="tooltip"]').tooltip();
    }
    
    render() {
        return (
            <React.Fragment>
            <div className="row">
                <div className="col-sm-12">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/home">ダッシュボード</a></li>
                            <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/staffs">ワーカー一覧</a></li>
                            <li className="breadcrumb-item active" aria-current="page">ワーカー編集</li>
                        </ol>
                    </nav>
                </div>
            </div>
            <main id="main" onMouseOver={this.onHoverTooltip}>
                <div className="row justify-content-md-center">
                    <div className="col-sm-9">
                        <div className="card mb-3">
                            <div className="card-header p-4 border-bottom-0"><h4 className="mb-0">ログイン情報</h4></div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">メールアドレス</label>
                                            {
                                                React.createElement(
                                                        'input',
                                                        {type: 'text', onChange: this.handleInptChange, name: 'email', value: this.state.staff.email|| "", className: 'form-control'},
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">パスワード</label>
                                            {
                                                React.createElement(
                                                        'input',
                                                        {type: 'password', onChange: this.handleInptChange, name: 'password', className: 'form-control'},
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">パスワード確認</label>
                                            {
                                                React.createElement(
                                                        'input',
                                                        {type: 'password', onChange: this.handleInptChange, name: 'password_confirmation', className: 'form-control'},
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card mb-3">
                            <div className="card-header p-4 border-bottom-0"><h4 className="mb-0">面接情報</h4></div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">ステータス</label>
                                            <input type="text" value={this.state.staff.status ? this.processStatus(this.state.staff.status) : '未承認'} disabled className="form-control cls-status"/>
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">面接日</label>
                                            <div className="input-group">
                                                <DatePicker
                                                    locale="ja-JP"
                                                    className="form-control form_datepicker"
                                                    dateFormat="YYYY/MM/DD"
                                                    selected={moment(new Date(this.state.staff.date_interview))}
                                                    onChange={this.handleChangeEditDateInterview}
                                                    placeholderText="面接日を選択"
                                                    disabledKeyboardNavigation
                                                />
                                                <div className="input-group-append">
                                                    <button className="btn btn-outline-secondary" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">面接時間</label>
                                            <ConstElement onElementChange={this.handleInptChange} element ="time_interview" value={this.state.staff.time_interview ? this.state.staff.time_interview : ''} />
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">面接方法</label>
                                            <ConstElement onElementChange={this.handleInptChange} element ="method_interview" value={this.state.staff.method_interview ? this.state.staff.method_interview : ''} />
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">コンタクトID</label>
                                            <input type="text" onChange={this.handleInptChange} name="contact_id_interview" value={this.state.staff.contact_id_interview ? this.state.staff.contact_id_interview : ""} className="form-control"/>
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">理由</label>
                                            <ConstElement element ="reject_reason" onElementChange={this.handleInptChange} value={this.state.staff.reject_reason ? this.state.staff.reject_reason : ''} />
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">反社チェック</label>
                                            <ConstElement element ="anti_check" onElementChange={this.handleInptChange} value={this.state.staff.anti_check ? this.state.staff.anti_check : ''} />
                                            <p className="mt-3">
                                                <a href={"https://www.google.co.jp/search?q=" + this.state.staff.firstname + this.state.staff.lastname} target="_blank" className="text-danger">
                                                    <strong>{this.state.staff.firstname + this.state.staff.lastname}をgoogleでチェックする</strong>
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className="row">
                                            <div className="col-sm-4 block-hidden">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="">プロフィール画像</label>
                                                    { this.state.staff.profile_img_file != 'no' && this.state.staff.profile_img_file ? (
                                                        <a data-toggle="tooltip" url={this.state.staff.id ? "/api/staffs/" + this.state.staff.id + "/image/profile" : ''} className="cls-image clickable" title="元画像を見る" onClick={this.showImgOriginal}>
                                                            <img src={this.state.staff.profile_img_file} id="img-profile_img_file" className="imagePreview img-thumbnail" />
                                                        </a>
                                                    ) : null }
                                                    {
                                                        React.createElement(
                                                                'input',
                                                                {type: 'file', onChange: this.handlePreviewImg, name: 'profile_img_file', className: 'btn w-100'},
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="">本人確認画像 1枚目</label><br/>
                                                    { this.state.staff.identification_img_file != 'no' && this.state.staff.identification_img_file ? (
                                                        <a data-toggle="tooltip" url={this.state.staff.id ? "/api/staffs/" + this.state.staff.id + "/image/identification-file" : ''} className="cls-image clickable" title="元画像を見る" onClick={this.showImgOriginal}>
                                                            <img src={this.state.staff.identification_img_file} width= {this.state.imgIdentification.width} height= {this.state.imgIdentification.height} id="img-identification_img_file" className="imagePreview img-thumbnail" />
                                                        </a>
                                                    ) : null }
                                                    {
                                                        React.createElement(
                                                                'input',
                                                                {type: 'file', accept: '.png, .jpg', onChange: this.handlePreviewImg, name: 'identification_img_file', className: 'btn w-100', id: 'id_identification_img_file'},
                                                    )}
                                                    <div id="identificationCanvas" className="block-hidden">
                                                        <AvatarEditor
                                                            ref={(avatarEditor) => {
                                                                window.avatarEditorImgIden = avatarEditor
                                                            }}
                                                            image={this.state.imgIdentification.img}
                                                            width={this.state.imgIdentification.width}
                                                            height={this.state.imgIdentification.height}
                                                            border={30}
                                                            color={[51, 51, 51, 0.3]}
                                                            rotate={0}
                                                            />
                                                        <div className="">
                                                            <div id="btn-crop-image-file" className="btn btn-primary" onClick={this.cropImageIdentification}>画像をクロップ</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="">本人確認画像 2枚目</label><br/>
                                                    { this.state.staff.identification_img_file_back != 'no' && this.state.staff.identification_img_file_back ? (
                                                        <a data-toggle="tooltip" url={this.state.staff.id ? "/api/staffs/" + this.state.staff.id + "/image/identification-file-back" : ''} className="cls-image clickable" title="元画像を見る" onClick={this.showImgOriginal}>    
                                                            <img src={this.state.staff.identification_img_file_back} width= {this.state.imgIdentificationFileBack.width} height= {this.state.imgIdentificationFileBack.height} id="img-identification_img_file_back" className="imagePreview img-thumbnail" />
                                                        </a>
                                                    ) : null }
                                                    {
                                                        React.createElement(
                                                                'input',
                                                                {type: 'file', accept: '.png, .jpg', onChange: this.handlePreviewImg, name: 'identification_img_file_back', className: 'btn w-100', id: 'id_identification_img_file_back'},
                                                    )}
                                                    <div id="identificationFileBackCanvas" className="block-hidden">
                                                        <AvatarEditor
                                                            ref={(avatarEditor) => {
                                                                window.avatarEditorImgIdenFileBack = avatarEditor
                                                            }}
                                                            image={this.state.imgIdentificationFileBack.img}
                                                            width={this.state.imgIdentificationFileBack.width}
                                                            height={this.state.imgIdentificationFileBack.height}
                                                            border={30}
                                                            color={[51, 51, 51, 0.3]}
                                                            rotate={0}
                                                            />
                                                        <div className="">
                                                            <div id="btn-crop-image-file-back" className="btn btn-primary" onClick={this.cropImageIdentificationFileBack}>画像をクロップ</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="">本人確認画像 3枚目</label><br/>
                                                    { this.state.staff.identification_img_file_back2 != 'no' && this.state.staff.identification_img_file_back2 ? (
                                                        <a data-toggle="tooltip" url={this.state.staff.id ? "/api/staffs/" + this.state.staff.id + "/image/identification-file-back2" : ''} className="cls-image clickable" title="元画像を見る" onClick={this.showImgOriginal}>    
                                                            <img src={this.state.staff.identification_img_file_back2} width= {this.state.imgIdentificationFileBack2.width} height= {this.state.imgIdentificationFileBack2.height} id="img-identification_img_file_back2" className="imagePreview img-thumbnail" />
                                                        </a>
                                                    ) : null }
                                                    {
                                                        React.createElement(
                                                                'input',
                                                                {type: 'file', accept: '.png, .jpg', onChange: this.handlePreviewImg, name: 'identification_img_file_back2', className: 'btn w-100', id: 'id_identification_img_file_back2'},
                                                    )}
                                                    <div id="identificationFileBack2Canvas" className="block-hidden">
                                                        <AvatarEditor
                                                            ref={(avatarEditor) => {
                                                                window.avatarEditorImgIdenFileBack2 = avatarEditor
                                                            }}
                                                            image={this.state.imgIdentificationFileBack2.img}
                                                            width={this.state.imgIdentificationFileBack2.width}
                                                            height={this.state.imgIdentificationFileBack2.height}
                                                            border={30}
                                                            color={[51, 51, 51, 0.3]}
                                                            rotate={0}
                                                            />
                                                        <div className="">
                                                            <div id="btn-crop-image-file-back2" className="btn btn-primary" onClick={this.cropImageIdentificationFileBack2}>画像をクロップ</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="">メモ</label>
                                                    <textarea onChange={this.handleInptChange} name="remark" value={this.state.staff.remark ? this.state.staff.remark : ''} className="form-control" rows="4"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="">個人認証</label>
                                                    <ConstElement onElementChange={this.handleInptChange} element="confirmed_at" value={this.state.staff.confirmed_at ? 1 : ''} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card mb-3">
                            <div className="card-header p-4 border-bottom-0"><h4 className="mb-0">個人情報</h4></div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">お名前</label>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <input type="text" onChange={this.handleInptChange} name="firstname" value={this.state.staff.firstname ? this.state.staff.firstname : ''} className="form-control" placeholder="山田"/>
                                                </div>
                                                <div className="col-sm-6">
                                                    <input type="text" onChange={this.handleInptChange} name="lastname" value={this.state.staff.lastname ? this.state.staff.lastname : ''} className="form-control" placeholder="太郎"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">お名前（フリガナ）</label>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <input type="text" onChange={this.handleInptChange} name="hiragana_firstname" value={this.state.staff.hiragana_firstname ? this.state.staff.hiragana_firstname : ''} className="form-control" placeholder="ヤマダ" />
                                                </div>
                                                <div className="col-sm-6">
                                                    <input type="text" onChange={this.handleInptChange} name="hiragana_lastname" value={this.state.staff.hiragana_lastname ? this.state.staff.hiragana_lastname : ''} className="form-control" placeholder="タロウ" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">ニックネーム（表示名）</label>
                                            <div className="input-group">
                                                {
                                                    React.createElement(
                                                            'input',
                                                            {type: 'text', onChange: this.handleInptChange, name: 'nickname', value: this.state.staff.nickname|| "", className: 'form-control'},
                                                )}
                                                <div className="input-group-append">
                                                    <span className="input-group-text">さん</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">電話番号</label>
                                            {
                                                React.createElement(
                                                        'input',
                                                        {type: 'text', onChange: this.handleInptChange, name: 'tel', value: this.state.staff.tel|| "", className: 'form-control'},
                                            )}
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">誕生日</label>
                                            <div className="input-group">
                                                <DatePicker
                                                    locale="ja-JP"
                                                    className="form-control form_datepicker"
                                                    dateFormat="YYYY/MM/DD"
                                                    selected={moment(new Date(this.state.staff.birthday))}
                                                    onChange={this.handleChangeBirthday}
                                                    disabledKeyboardNavigation
                                                />
                                                <div className="input-group-append">
                                                    <button className="btn btn-outline-secondary" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">性別</label>
                                            <ConstElement onElementChange={this.handleInptChange} element ="gender" value={this.state.staff.gender ? this.state.staff.gender : ''} />
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">採用後キャンセル</label>
                                            {
                                                React.createElement(
                                                        'input',
                                                        {type: 'number', onChange: this.handleInptChange, name: 'cancel_apply_count', value: this.state.staff.cancel_apply_count || 0, className: 'form-control'},
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">郵便番号</label>
                                            {
                                                React.createElement(
                                                        'input',
                                                        {type: 'text', onChange: this.handleInptChange, name: 'zip_no', defaultValue: this.state.staff.zip_no|| "", placeholder: "1540001", className: 'form-control'},
                                            )}
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">都道府県</label>
                                            <select onChange={this.handleInptChange} name="pref" value={this.state.staff.pref ? this.state.staff.pref : ''} className="myform-select form-control" >
                                                {this.state.prefs.map((dataRow, i) => {
                                                        return <option key={i} value={dataRow.id}>{dataRow.name}</option>;
                                                })}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">市区</label>
                                            <select onChange={this.handleInptChange} name="city" value={this.state.staff.city ? this.state.staff.city : ''} className="myform-select form-control" >
                                                {this.state.cities.filter(city => city.pref_id == this.state.staff.pref).map((dataRow, i) => {
                                                        return <option key={i} value={dataRow.id}>{dataRow.name}</option>;
                                                })}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">町名・番地</label>
                                            {
                                                React.createElement(
                                                        'input',
                                                        {type: 'text', onChange: this.handleInptChange, name: 'address', value: this.state.staff.address|| "", className: 'form-control'},
                                            )}
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">ビル・建物名</label>
                                            {
                                                React.createElement(
                                                        'input',
                                                        {type: 'text', onChange: this.handleInptChange, name: 'address2', value: this.state.staff.address2|| "", className: 'form-control'},
                                            )}
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">ワーカー番号</label>
                                            {
                                                React.createElement(
                                                        'input',
                                                        {type: 'number', onChange: this.handleInptChange, name: 'staff_no', value: this.state.staff.staff_no|| "", className: 'form-control'},
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card mb-3 block-hidden">
                            <div className="card-header p-4 border-bottom-0"><h4 className="mb-0">シェアジョブ情報</h4></div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">欠勤回数</label>
                                            <div className="input-group">
                                                {
                                                    React.createElement(
                                                            'input',
                                                            {type: 'number', onChange: this.handleInptChange, name: 'absence_count', value: this.state.staff.absence_count|| "", className: 'form-control'},
                                                )}
                                                <div className="input-group-append">
                                                    <span className="input-group-text" id="">回</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">評価件数</label>
                                            <div className="input-group">
                                                {
                                                    React.createElement(
                                                            'input',
                                                            {type: 'number', onChange: this.handleInptChange, name: 'evaluation_count', value: this.state.staff.evaluation_count|| "", className: 'form-control'},
                                                )}
                                                <div className="input-group-append">
                                                    <span className="input-group-text" id="">件</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">お仕事応募件数</label>
                                            <div className="input-group">
                                                {
                                                    React.createElement(
                                                            'input',
                                                            {type: 'number', onChange: this.handleInptChange, name: 'job_apply_count', value: this.state.staff.job_apply_count|| "", className: 'form-control'},
                                                )}
                                                <div className="input-group-append">
                                                    <span className="input-group-text" id="">件</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">遅刻回数</label>
                                            <div className="input-group">
                                                {
                                                    React.createElement(
                                                            'input',
                                                            {type: 'number', onChange: this.handleInptChange, name: 'late_times', value: this.state.staff.late_times|| "", className: 'form-control'},
                                                )}
                                                <div className="input-group-append">
                                                    <span className="input-group-text" id="">回</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">平均評価</label>
                                            <div className="input-group">
                                                {
                                                    React.createElement(
                                                            'input',
                                                            {type: 'number', onChange: this.handleInptChange, name: 'evaluation_avg', value: this.state.staff.evaluation_avg|| "", className: 'form-control'},
                                                )}
                                                <div className="input-group-append">
                                                    <span className="input-group-text" id="">件</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">評価ポイント合計</label>
                                            <div className="input-group">
                                                {
                                                    React.createElement(
                                                            'input',
                                                            {type: 'number', onChange: this.handleInptChange, name: 'evaluation_points', value: this.state.staff.evaluation_points|| "", className: 'form-control'},
                                                )}
                                                <div className="input-group-append">
                                                    <span className="input-group-text" id="">pt</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">早退回数</label>
                                            <div className="input-group">
                                                {
                                                    React.createElement(
                                                            'input',
                                                            {type: 'number', onChange: this.handleInptChange, name: 'leave_times', value: this.state.staff.leave_times|| "", className: 'form-control'},
                                                )}
                                                <div className="input-group-append">
                                                    <span className="input-group-text" id="">回</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">現在のポイント</label>
                                            <div className="input-group">
                                                {
                                                    React.createElement(
                                                            'input',
                                                            {type: 'number', onChange: this.handleInptChange, name: 'current_point', value: this.state.staff.current_point|| "", className: 'form-control'},
                                                )}
                                                <div className="input-group-append">
                                                    <span className="input-group-text" id="">pt</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="">特記事項</label>
                                            {
                                                React.createElement(
                                                        'input',
                                                        {type: 'text', onChange: this.handleInptChange, name: 'remark', value: this.state.staff.remark|| "", className: 'form-control'},
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-5">
                            <div className="col-sm-12">
                                <div className="card-footer">
                                    <div className="text-center">
                                        <button onClick={this.saveData} className="text-center btn btn-primary btn-radius btn-lg btn-space"><span className="size-inherit">保存する</span></button>
                                        { this.state.staff.status == 1  ? 
                                            <button onClick={this.updateStatus} status="8" className="btn bg-pink text-white btn-radius btn-lg"><span className="size-inherit">アカウント停止</span></button>
                                        : '' }
                                        { this.state.staff.status == 8  ? 
                                            <button onClick={this.updateStatusRecoverAccount} status="1" className="btn bg-pink text-white btn-radius btn-lg"><span className="size-inherit">アカウント復旧</span></button>
                                        : '' }
                                    </div>
                                </div>
                            </div>
                        </div>
                        { this.state.staff.status == 0 || this.state.staff.status == null ?
                            <div className={`row footer-status block-hidden-important ${this.state.staff.status == 0 || this.state.staff.status ? 'block-display-important':''}`}>
                                <div className="col-sm-12">
                                    <div className="row">
                                        <div className="col-sm-12 text-center">
                                            <p>このワーカーを承認しますか？</p>
                                            <ul className="list-inline">
                                                <li className="list-inline-item"><button onClick={this.updateStatus} status="1" className="btn btn-primary btn-radius"><span className="size-inherit">承認する</span></button></li>
                                                <li className="list-inline-item"><button onClick={this.updateStatus} status="9" className="btn btn-default btn-radius"><span className="size-inherit">非承認にする</span></button></li>
                                                <li className="list-inline-item"><button onClick={this.deleteAccount} className="btn bg-pink text-white btn-radius"><span className="size-inherit">アカウント削除</span></button></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        : '' }
                    </div>
                </div>
            </main>
            <ToastContainer />
        </React.Fragment>
        )
    }
}
